class ProdutoCadastroModal {
    static get $inject() {
        return ['$scope', 'gql', 'Legislacao', 'Produtos']
    }

    constructor(scope, gql, Legislacao, Produtos) {
        this.apply = (fn) => scope.$apply(fn)
        this.gql = gql
        this.Legislacao = Legislacao
        this.Produtos = Produtos

        this.produto = {}
    }

    $onInit() {
        this.loadingPromise =
            this.loadTiposDestinacao()
                .then(() => {
                    if (this.resolve.produto) {
                        let { tipoDestinacao, ...produto } = this.resolve.produto

                        delete produto["foto"]

                        this.produto = {
                            ...produto,
                            tipoDestinacao: tipoDestinacao ? tipoDestinacao.codigo : null
                        }
                    }
                })
                .finally(() => this.apply())
    }

    submit() {
        if (this.form && this.form.$valid) {
            const { id: produtoId, foto: foto, ...params } = this.produto

            this.savePromise = produtoId
                ? this.Produtos.updateProduto(this.resolve.empresaId, produtoId, params, foto)
                : this.Produtos.createProduto(this.resolve.empresaId, this.resolve.filialId, params, foto)

            this.savePromise
                .then(produto => this.close({ $value: { produto } }))
                .catch(errors => errors.forEach(error => this.handleError(error)))
                .finally(() => this.apply())
        }
    }

    loadTiposDestinacao() {
        return this.Legislacao
            .listTiposDestinacao()
            .then(tiposDestinacao =>
                this.tiposDestinacao = tiposDestinacao.map(t => ({ ...t, descricao: `${t.codigo} - ${t.descricao}` }))
            )
    }

    handleError(error) {
        if (error.key === 'codigo') {
            this.form.codigo.$setValidity('codigoExists', false)
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("produtoCadastroModal", {
        controller: ProdutoCadastroModal,
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        },
        template: `
            <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
                <modal modal-title="Alterar o tipo de destinação" close="$ctrl.close">
                    <modal-body>
                        <div class="row no-margin">
                            <div>
                                <div>
                                    <div class="form-group col-xs-12 col-md-3">
                                        <label class="text-bold" style="font-size: 15px;">Código</label>
                                        <br>
                                        <span>{{$ctrl.produto.codigo}}</span>
                                    </div>
                                    <div class="form-group col-xs-12 col-md-12">
                                        <label class="text-bold" style="font-size: 15px;">Descrição</label>
                                        <br>
                                        <span>{{$ctrl.produto.descricao}}</span>
                                    </div>
                           
                                    <div class="form-group col-xs-12 col-md-12">
                                        <label class="text-bold">Tipos de destinação</label>
                                        <select 
                                            class="form-control" 
                                            name="tipo_destinacao" 
                                            ng-model="$ctrl.produto.tipoDestinacao"
                                            ng-options="tipo.codigo as tipo.descricao for tipo in $ctrl.tiposDestinacao">
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </modal-body>
                    <modal-footer>
                        <promise-tracker promise="$ctrl.savePromise" active="isSaving"></promise-tracker>
                        <button type="submit" class="btn btn-primary" ng-hide="isSaving">Salvar</button>
                        <button type="button" class="btn btn-primary" ng-show="isSaving" disabled>
                            <i class="fa fa-circle-o-notch fa-spin"></i> Salvando...
                        </button>

                        <button type="button" class="btn btn-default" ng-click="$ctrl.dismiss()">Fechar</button>
                    </modal-footer>
                </modal>
            </form>
        `
    })
